const comments = [
  {
    name: '影迷小陈',
    avatar: 'C',
    rating: 5,
    text: '一直在用西瓜影视追剧，蓝光画质真的绝了，而且完全不卡顿，比之前用的几个平台好太多了！',
    time: '2小时前',
    tag: '画质党',
  },
  {
    name: '追剧达人Linda',
    avatar: 'L',
    rating: 5,
    text: '资源更新速度很快，新剧上线当天就能看了。字幕翻译质量也不错，推荐给身边所有朋友了。',
    time: '5小时前',
    tag: '追剧狂魔',
  },
  {
    name: '老张看电影',
    avatar: '张',
    rating: 5,
    text: '作为一个看了二十多年电影的老影迷，西瓜影视的片库确实丰富，很多经典老片都能找到高清版本。',
    time: '1天前',
    tag: '资深影迷',
  },
  {
    name: '茉莉花开',
    avatar: '茉',
    rating: 4,
    text: '界面简洁清爽没有广告弹窗，观影体验很纯粹。希望以后能增加更多海外剧集资源。',
    time: '1天前',
    tag: '体验党',
  },
  {
    name: '科技圈阿杰',
    avatar: '杰',
    rating: 5,
    text: '4K画质配合我家的大屏电视简直完美，加载速度也很快，即点即播不用等缓冲。技术团队给力！',
    time: '2天前',
    tag: '画质控',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              观众热评
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              听听全国各地影迷对西瓜影视的真实使用感受
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {comments.map((comment, idx) => (
              <div
                key={idx}
                className="bg-background-100 rounded-xl p-5 flex flex-col gap-3"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-sm font-bold text-primary-600">{comment.avatar}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{comment.name}</p>
                    <div className="flex items-center gap-0.5 mt-0.5">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`ri-star-fill text-xs ${
                            i < comment.rating ? 'text-accent-500' : 'text-background-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                  </div>
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                    {comment.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
                <p className="text-xs text-foreground-400">{comment.time}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}